import { Object } from '@common/Object/Object'
import { is } from '@common/is/is'

import type { TRoutes } from '../definitions'

import getPartsFromPath from './getPartsFromPath'

/**
 * Egy adott url path alapján visszaadja a callbackeket.
 * @param path   - Az url path.
 * @param routes - Az összes route, amiből ki kell szűrni a jókat.
 */
export default function getRoutesByPath (path: string, routes: TRoutes): TRoutes {
  /*
    /a/b/c/d
    →
    [ 'a', 'b', 'c', 'd' ]
  */
  const pathParts = getPartsFromPath(path)

  const pathRoutes: TRoutes = Object.getKeys(routes).reduce((acc: TRoutes, curr) => {
    /*
      /a/:param1/c/:param2
      →
      [ 'a', ':param1', 'c', ':param2' ]
    */
    const routeParts = getPartsFromPath(curr)

    if (routeParts.length !== pathParts.length) {
      return acc
    }

    const isFound = routeParts.every((routePart, index) => {
      const value = pathParts[index]

      return (
        !is.undefined(value) &&
        (
          routePart.startsWith(':')  ||
          value === routePart
        )
      )
    })

    if (isFound) {
      acc[curr] = routes[curr]
    }

    return acc
  }, {})

  return pathRoutes
}
